import type { SessionRecord } from 'Grading';

/** A record held until the sitting's open answers, linked then to the sitting's id when it has one. */
export function linkedToSitting(
  record: SessionRecord,
  playSessionId: string | null,
): SessionRecord {
  return playSessionId === null || record.header.surfaceSessionId !== null
    ? record
    : { ...record, header: { ...record.header, surfaceSessionId: playSessionId } };
}
